/**
 * Extension package scanning (Phase 2) — shared contracts. See docs/design/security-roadmap-v1.md.
 * Verdicts are evidence-based and never inferred from obfuscation or privilege alone.
 */
import type { ChangeSeverity } from './types.js';

export const EXTENSION_VERDICTS = ['known_malicious', 'suspicious', 'elevated', 'clean', 'unknown'] as const;
export type ExtensionVerdict = (typeof EXTENSION_VERDICTS)[number];

export type FindingSeverity = ChangeSeverity;

export interface ScanEvidence {
  file?: string;
  line?: number;
  /** ≤ 200 chars of the matched code, control characters removed. */
  snippet?: string;
  value?: string;
}

export interface ScanFinding {
  /** Stable code, e.g. "code.remote_script_load", "net.new_destination", "intel.known_bad_hash". */
  code: string;
  severity: FindingSeverity;
  title: string;
  evidence: ScanEvidence[];
}

export interface ExtensionScanResult {
  packageSha256: string;
  extensionId: string;
  version: string;
  verdict: ExtensionVerdict;
  /** One sentence explaining the verdict, from the findings. */
  verdictReason: string;
  findings: ScanFinding[];
  /** Network destinations (hosts) referenced by the code or manifest, sorted unique. */
  networkDestinations: string[];
  stats: { files: number; bytes: number; jsFiles: number; jsBytes: number; obfuscationScore: number };
  analyzerVersion: string;
  analyzedAt: string;
}
